export const VF_CONTENT = {
  hero: {
    kicker: 'Para empresas com veículos próprios na operação',
    title: 'Você sabe exatamente quanto cada veículo da sua frota está custando por mês?',
    subtitle:
      'Cadastre veículos, registre abastecimentos e manutenções, e descubra o custo real por km rodado — sem depender de planilha desatualizada.',
    cta: 'Quero controlar minha frota',
    ctaMessage: 'Quero conhecer o controle de frota de veículos do 77Gestão',
    urgency: 'Enquanto a planilha fica desatualizada, o prejuízo com combustível e manutenção continua correndo.',
  },

  statsStrip: [
    { number: '100%', label: 'dos veículos com histórico completo', icon: 'fa-solid fa-car' },
    { number: 'R$/km', label: 'custo real calculado automaticamente', icon: 'fa-solid fa-gas-pump' },
    { number: '1 lugar', label: 'para controlar toda a frota', icon: 'fa-solid fa-clipboard-list' },
  ],

  pain: {
    title: 'Se sua frota ainda é controlada de cabeça ou em planilha, esses problemas são só questão de tempo',
    intro:
      'Empresas com carros, caminhões ou motos próprios sentem no bolso quando não têm controle real da frota. O problema não é o veículo — é a falta de informação para decidir.',
    items: [
      { icon: 'fa-solid fa-gas-pump', text: 'Você não sabe quanto cada veículo gasta de combustível por mês — só sente o rombo no caixa.' },
      { icon: 'fa-solid fa-screwdriver-wrench', text: 'Manutenção que deveria ser preventiva vira quebra no meio da operação, parando entrega ou serviço.' },
      { icon: 'fa-solid fa-table-list', text: 'Planilha de controle de frota desatualizada, com dados que ninguém confia mais.' },
      { icon: 'fa-solid fa-magnifying-glass-dollar', text: 'Impossível saber qual veículo compensa manter e qual está custando mais do que deveria.' },
      { icon: 'fa-solid fa-file-circle-question', text: 'Sem histórico de manutenção por veículo, cada troca de mecânico é um recomeço do zero.' },
    ],
  },

  midCta: {
    text: 'E se você soubesse, em segundos, o custo por km de cada veículo da frota?',
    cta: 'Quero ver como funciona',
    ctaMessage: 'Quero ver uma demonstração do controle de frota do 77Gestão',
  },

  solution: {
    title: 'Controle de frota simples, sem GPS e sem complicação — só o que realmente importa para sua gestão',
    intro:
      'O módulo de frota do 77Gestão registra o que acontece com cada veículo no dia a dia da sua operação, para você decidir com dado, não com achismo.',
    cards: [
      {
        icon: 'fa-solid fa-car-side',
        title: 'Cadastro completo de veículos',
        text: 'Registre cada carro, caminhão ou moto da frota com placa, modelo, ano e responsável — tudo em um só lugar.',
      },
      {
        icon: 'fa-solid fa-gas-pump',
        title: 'Registro de abastecimento',
        text: 'Lance litros, km rodado e valor a cada abastecimento. O sistema organiza o histórico automaticamente.',
      },
      {
        icon: 'fa-solid fa-screwdriver-wrench',
        title: 'Histórico de manutenções',
        text: 'Cada troca de óleo, revisão ou reparo fica registrado no histórico do veículo — sem depender da memória de ninguém.',
      },
      {
        icon: 'fa-solid fa-calculator',
        title: 'Custo por km rodado',
        text: 'O sistema calcula automaticamente quanto cada veículo custa por km, considerando combustível e manutenção.',
      },
      {
        icon: 'fa-solid fa-chart-column',
        title: 'Comparativo entre veículos',
        text: 'Veja lado a lado qual veículo está custando mais e decida sobre manter, vender ou substituir com base em número real.',
      },
    ],
  },

  proof: {
    title: 'O que muda quando a frota deixa de ser um mistério',
    intro:
      'Uma empresa com frota própria de entrega controlava tudo em planilha e só descobria o gasto real no fechamento do mês, quando já era tarde para agir.',
    stats: [
      { number: '100%', label: 'dos abastecimentos e manutenções registrados' },
      { number: 'R$/km', label: 'visível por veículo, a qualquer momento' },
      { number: '0', label: 'quebras por manutenção esquecida' },
    ],
    paragraphs: [
      'Depois de cadastrar a frota e passar a registrar cada abastecimento e manutenção no sistema, o dono passou a saber exatamente quanto cada veículo custava por km rodado.',
      'Isso tornou possível identificar o veículo mais caro da frota e tomar a decisão de substituição com base em dado — não em impressão.',
    ],
    highlight: 'Resultado: decisões sobre a frota deixaram de ser no feeling e passaram a ser com número na mão.',
    cta: 'Quero esse controle na minha frota',
    ctaMessage: 'Vi o resultado e quero controlar minha frota com o 77Gestão',
  },

  benefits: {
    title: 'Os três pilares do controle de frota',
    items: [
      {
        icon: 'fa-solid fa-eye',
        title: 'Visibilidade',
        text: 'Saiba o custo de cada veículo, o histórico de manutenção e o consumo de combustível a qualquer momento.',
      },
      {
        icon: 'fa-solid fa-sliders',
        title: 'Controle',
        text: 'Cada abastecimento e manutenção registrado no veículo certo, sem depender de planilha ou papel.',
      },
      {
        icon: 'fa-solid fa-binoculars',
        title: 'Previsibilidade',
        text: 'Histórico completo ajuda a planejar a próxima manutenção antes que ela vire uma quebra inesperada.',
      },
    ],
  },

  differentials: {
    title: 'Por que empresas com frota própria escolhem o 77Gestão',
    items: [
      { icon: 'fa-solid fa-puzzle-piece', text: 'Sistema simples, sem exigir rastreador ou equipamento extra instalado no veículo.' },
      { icon: 'fa-solid fa-handshake', text: 'Implantação acompanhada: sua equipe aprende a lançar abastecimento e manutenção do jeito certo desde o início.' },
      { icon: 'fa-solid fa-headset', text: 'Suporte humano, próximo e muito bem avaliado, sempre que surgir dúvida.' },
      { icon: 'fa-solid fa-link', text: 'Frota integrada ao financeiro do 77Gestão — o gasto com veículo entra automaticamente no seu controle financeiro.' },
    ],
  },

  faq: {
    title: 'Perguntas comuns antes de começar',
    items: [
      {
        question: 'O sistema faz rastreamento por GPS dos veículos?',
        answer:
          'Não. O 77Gestão controla o cadastro de veículos, abastecimentos, manutenções e custo por km — não é um sistema de rastreamento em tempo real nem de roteirização. O foco é dar visibilidade financeira e de manutenção da frota.',
      },
      {
        question: 'Preciso instalar algum equipamento no veículo?',
        answer:
          'Não. Todo o controle é feito por lançamentos no sistema — abastecimento, km rodado e manutenção são registrados manualmente pela equipe responsável, sem necessidade de hardware instalado no veículo.',
      },
      {
        question: 'Minha frota é pequena, vale a pena?',
        answer:
          'Vale. Mesmo com poucos veículos, saber o custo real por km evita decisões erradas, como manter um veículo que já não compensa. O sistema se adapta ao tamanho da sua frota.',
      },
      {
        question: 'Como funciona o cálculo de custo por km?',
        answer:
          'O sistema soma os gastos registrados de combustível e manutenção do veículo e divide pelos quilômetros rodados no período, mostrando o custo real de cada veículo automaticamente.',
      },
      {
        question: 'Dá para acompanhar manutenção preventiva pelo sistema?',
        answer:
          'Sim. Cada manutenção fica registrada no histórico do veículo, permitindo enxergar padrões e se organizar para agir antes que o problema vire quebra.',
      },
    ],
  },

  ctaFinal: {
    title: 'Pare de administrar a frota no escuro.',
    subtitle:
      'Agende uma demonstração e veja como ter o custo real de cada veículo, sem GPS, sem planilha e sem surpresa no fim do mês.',
    cta: 'Agendar demonstração agora',
    ctaMessage: 'Quero agendar uma demonstração do controle de frota do 77Gestão',
  },

  seo: {
    title: 'Sistema de Controle de Frota de Veículos | 77Gestão',
    description:
      'Software de gestão de veículos para controlar abastecimento, manutenção e custo por km da sua frota. Simples, sem GPS. Agende uma demonstração gratuita.',
  },
};
